import React from "react";
import Banner from "./Banner";
import YoutubeVideo from "./YoutubeVideo";
import LandingFooter from "../../../components/landingFooter";
import AppHeader from "../../../components/Header";

function AboutUs() {
  return (
    <AppHeader>
      <Banner />
      <YoutubeVideo />
      {/* <LandingFooter /> */}
    </AppHeader>
  );
}

export default AboutUs;
